var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.orderData.length === 0 ? _c("no-data") : _vm._e(),
      _c(
        "div",
        { staticClass: "box-shadow orderList" },
        [
          _vm._l(_vm.orderData, function (order, index) {
            return _c(
              "div",
              {
                key: index,
                on: {
                  click: function ($event) {
                    return _vm.selectCard(order, index)
                  },
                },
              },
              [
                _c(
                  "el-card",
                  {
                    class: {
                      "is-selected": _vm.orderId === order.sid,
                      marginBottom10: 1,
                    },
                    attrs: {
                      shadow: "hover",
                      "body-style": "background-color: white;height: 120px;",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "clearfix flex marginBottom10",
                        staticStyle: { "align-items": "flex-end" },
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [
                        _c("span", {
                          staticStyle: { height: "35px", width: "10px" },
                        }),
                        _c("span", { staticClass: "marginLeft5 blue fs19" }, [
                          _vm._v(" " + _vm._s(order.ctopsNo)),
                        ]),
                        _vm._v("  "),
                        order.bdelivery === 2
                          ? _c(
                              "span",
                              [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: { type: "success", effect: "dark" },
                                  },
                                  [_vm._v("自提")]
                                ),
                                _vm._v("   "),
                              ],
                              1
                            )
                          : order.bdelivery === 3
                          ? _c(
                              "span",
                              [
                                _c(
                                  "el-tag",
                                  { attrs: { type: "danger", effect: "dark" } },
                                  [_vm._v("专")]
                                ),
                                _vm._v("   "),
                              ],
                              1
                            )
                          : _vm._e(),
                        order.bpreOrder === 1
                          ? _c(
                              "span",
                              [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: { type: "warning", effect: "dark" },
                                  },
                                  [_vm._v("预")]
                                ),
                                _vm._v("   "),
                              ],
                              1
                            )
                          : _vm._e(),
                        order.bplatType === 1
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "orange",
                                  "line-height": "22px",
                                },
                              },
                              [_vm._v("美团闪购")]
                            )
                          : order.bplatType === 2
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "#409EFF",
                                  "line-height": "22px",
                                },
                              },
                              [_vm._v("饿了么")]
                            )
                          : order.bplatType === 3
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "green",
                                  "line-height": "22px",
                                },
                              },
                              [_vm._v("京东到家")]
                            )
                          : order.bplatType === 4
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "grey",
                                  "line-height": "22px",
                                },
                              },
                              [_vm._v("小程序商城")]
                            )
                          : order.bplatType === 6
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  color: "grey",
                                  "line-height": "22px",
                                },
                              },
                              [_vm._v("Tops订单")]
                            )
                          : _vm._e(),
                        order.bstatus === 0
                          ? _c(
                              "span",
                              {
                                staticClass: "marginLeft5 grey",
                                staticStyle: { "line-height": "22px" },
                              },
                              [_vm._v(_vm._s(order.soverTime) + " 已完成 ")]
                            )
                          : order.bstatus === 1
                          ? _c(
                              "span",
                              {
                                staticClass: "marginLeft5 grey",
                                staticStyle: { "line-height": "22px" },
                              },
                              [_vm._v(_vm._s(order.sorderTime) + " 新订单 ")]
                            )
                          : order.bstatus === 2
                          ? _c(
                              "span",
                              {
                                staticClass: "marginLeft5 grey",
                                staticStyle: { "line-height": "22px" },
                              },
                              [_vm._v(_vm._s(order.sorderTime) + " 异常订单 ")]
                            )
                          : order.bstatus === 3
                          ? _c(
                              "span",
                              {
                                staticClass: "marginLeft5 grey",
                                staticStyle: { "line-height": "22px" },
                              },
                              [_vm._v("催单 ")]
                            )
                          : order.bstatus === 4
                          ? _c(
                              "span",
                              {
                                staticClass: "marginLeft5 grey",
                                staticStyle: { "line-height": "22px" },
                              },
                              [_vm._v("配送异常 ")]
                            )
                          : order.bstatus === 5
                          ? _c(
                              "span",
                              {
                                staticClass: "marginLeft5 grey",
                                staticStyle: { "line-height": "22px" },
                              },
                              [_vm._v("取消/退款 ")]
                            )
                          : order.bstatus === 6
                          ? _c(
                              "span",
                              {
                                staticClass: "marginLeft5 grey",
                                staticStyle: { "line-height": "22px" },
                              },
                              [_vm._v("预订单 ")]
                            )
                          : order.bstatus === 7
                          ? _c(
                              "span",
                              {
                                staticClass: "marginLeft5 grey",
                                staticStyle: { "line-height": "22px" },
                              },
                              [_vm._v("待抢单 ")]
                            )
                          : order.bstatus === 8
                          ? _c(
                              "span",
                              {
                                staticClass: "marginLeft5 grey",
                                staticStyle: { "line-height": "22px" },
                              },
                              [_vm._v("待取货 ")]
                            )
                          : order.bstatus === 9
                          ? _c(
                              "span",
                              {
                                staticClass: "marginLeft5 grey",
                                staticStyle: { "line-height": "22px" },
                              },
                              [_vm._v("配送中 ")]
                            )
                          : order.bstatus === 10
                          ? _c(
                              "span",
                              {
                                staticClass: "marginLeft5 grey",
                                staticStyle: { "line-height": "22px" },
                              },
                              [_vm._v("处理中 ")]
                            )
                          : order.bstatus === 11
                          ? _c(
                              "span",
                              {
                                staticClass: "marginLeft5 grey",
                                staticStyle: { "line-height": "22px" },
                              },
                              [_vm._v("未知 ")]
                            )
                          : order.bstatus === 12
                          ? _c(
                              "span",
                              {
                                staticClass: "marginLeft5 grey",
                                staticStyle: { "line-height": "22px" },
                              },
                              [_vm._v(_vm._s(order.soverTime) + " 加单完成 ")]
                            )
                          : order.bstatus === 13
                          ? _c(
                              "span",
                              {
                                staticClass: "marginLeft5 grey",
                                staticStyle: { "line-height": "22px" },
                              },
                              [_vm._v(_vm._s(order.soverTime) + " 已取消 ")]
                            )
                          : _vm._e(),
                        _c(
                          "span",
                          {
                            staticClass: "grey",
                            staticStyle: { "line-height": "22px" },
                          },
                          [
                            _vm._v(
                              " 订单编号：" + _vm._s(order.corderNo) + " "
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: "复制订单编号",
                                  placement: "top",
                                  effect: "light",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "el-icon-document-copy marginRight10",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.handleCopyOrderNo(
                                        order.corderNo
                                      )
                                    },
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v("    "),
                        _c(
                          "span",
                          { staticClass: "marginLeftAuto marginRight20" },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: "忽略订单",
                                  placement: "top",
                                  effect: "light",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-close marginRight10",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleUpdateStatusClose(order)
                                    },
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: "订单日志",
                                  placement: "top",
                                  effect: "light",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-document marginRight10",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleShowLogOrder(order)
                                    },
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: "撤回订单",
                                  placement: "top",
                                  effect: "light",
                                },
                              },
                              [
                                order.bplatType === 6
                                  ? _c("i", {
                                      staticClass: "el-icon-back marginRight10",
                                    })
                                  : _vm._e(),
                              ]
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: "删除订单",
                                  placement: "top",
                                  effect: "light",
                                },
                              },
                              [
                                order.bplatType === 6
                                  ? _c("i", {
                                      staticClass:
                                        "el-icon-delete marginRight10",
                                    })
                                  : _vm._e(),
                              ]
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: "发送短信",
                                  placement: "top",
                                  effect: "light",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "el-icon-s-comment marginRight10",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openMessageDialog(order)
                                    },
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: "发起聊天",
                                  placement: "top",
                                  effect: "light",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "el-icon-service marginRight10 chat-icon",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.handleStartChat(order)
                                    },
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _c(
                      "el-row",
                      [
                        _c("el-col", { attrs: { span: 18 } }, [
                          _c("div", [
                            _c("span", { staticClass: "marginLeftAuto" }, [
                              _c("a", { staticClass: "blue" }, [
                                _vm._v(_vm._s(order.sshop)),
                              ]),
                            ]),
                            _c("span", { staticClass: "C909399" }, [
                              _vm._v("#" + _vm._s(order.cplatNo)),
                            ]),
                          ]),
                          order.ccustomerName
                            ? _c("div", [
                                _c("div", { staticClass: "marginTop5" }, [
                                  _vm._v(
                                    " " + _vm._s(order.ccustomerName) + " "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "blue",
                                      on: {
                                        click: function ($event) {
                                          return _vm.callPhone(
                                            order.ccustomerPhonePrivate
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          order.ccustomerPhonePrivate
                                            ? order.ccustomerPhonePrivate
                                                .split("_")[0]
                                                .replace(
                                                  order.ccustomerPhonePrivate.substr(
                                                    3,
                                                    4
                                                  ),
                                                  "****"
                                                ) + "_****"
                                            : ""
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("div", { staticClass: "marginTop5" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "blue",
                                      on: {
                                        click: function ($event) {
                                          return _vm.checkMap(order)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(order.ccustomerAddrDetail))]
                                  ),
                                  order.sdistance
                                    ? _c("span", { staticClass: "grey" }, [
                                        _vm._v(
                                          "·" +
                                            _vm._s(order.sdistance / 1000) +
                                            "公里"
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "grey marginTop5" }, [
                            _vm._v(" 备注："),
                            order.sorderRemark !== "" &&
                            order.sorderRemark !== undefined &&
                            order.sorderRemark !== null
                              ? _c("span", [_vm._v(_vm._s(order.sorderRemark))])
                              : _vm._e(),
                          ]),
                          order.bstatus === 8 || order.bstatus === 9
                            ? _c("div", { staticClass: "grey marginTop5" }, [
                                order.bstatus === 8
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "black marginTop10 marginBottom10",
                                      },
                                      [_vm._v("接单成功")]
                                    )
                                  : _vm._e(),
                                order.bstatus === 9
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "black marginTop10 marginBottom10",
                                      },
                                      [_vm._v("配送中")]
                                    )
                                  : _vm._e(),
                                order.cdeliveryName
                                  ? _c(
                                      "div",
                                      [
                                        _vm._v(
                                          " 配送员: " +
                                            _vm._s(order.cdeliveryName) +
                                            ", "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "blue marginLeft5",
                                            on: {
                                              click: function ($event) {
                                                return _vm.callPhone(
                                                  order.cdeliveryPhone
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                order.cdeliveryPhone
                                                  ? order.cdeliveryPhone
                                                      .split("_")[0]
                                                      .replace(
                                                        order.cdeliveryPhone.substr(
                                                          3,
                                                          4
                                                        ),
                                                        "****"
                                                      ) + "_****"
                                                  : ""
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "el-tooltip",
                                          {
                                            staticClass:
                                              "item marginLeft5 pointer",
                                            attrs: {
                                              effect: "dark",
                                              content: "点击向骑手发起短信",
                                              placement: "bottom-start",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "iconfont",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.openMessageDialog(
                                                      order
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(_vm._s(""))]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          order.bstatus === 2
                            ? _c("div", { staticClass: "grey marginTop5" }, [
                                _vm._v(" 异常原因："),
                                _c("span", [_vm._v(_vm._s(order.serror))]),
                              ])
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _vm.total > _vm.orderData.length
            ? _c(
                "el-button",
                {
                  staticStyle: { width: "100%" },
                  attrs: { loading: _vm.btnLoading },
                  on: { click: _vm.handlePage },
                },
                [_vm._v("加载更多")]
              )
            : _vm._e(),
          _c(
            "el-dialog",
            {
              staticClass: "elDialog",
              attrs: {
                "close-on-click-modal": false,
                title: "查看位置",
                visible: _vm.addrDialogVisible,
                width: "800px",
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.addrDialogVisible = $event
                },
              },
            },
            [
              _vm.addrDialogVisible
                ? _c("getDeliveryRoutes", { attrs: { ord: _vm.orderInfo } })
                : _vm._e(),
            ],
            1
          ),
          _vm.messageDialogVisible
            ? _c(
                "el-dialog",
                {
                  staticClass: "videoDialog",
                  attrs: {
                    "close-on-click-modal": false,
                    title: "发送短信",
                    visible: _vm.messageDialogVisible,
                    width: "400px",
                    "append-to-body": "",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.messageDialogVisible = $event
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex alignItemsCenter marginBottom10" },
                    [
                      _c("div", { staticClass: "marginRight10" }, [
                        _vm._v("接收号码 :"),
                      ]),
                      _c("el-input", {
                        attrs: { clearable: "", placeholder: "请输入内容" },
                        model: {
                          value: _vm.receivePhone,
                          callback: function ($$v) {
                            _vm.receivePhone = $$v
                          },
                          expression: "receivePhone",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "marginBottom10" },
                    [
                      _c("div", { staticClass: "marginRight10" }, [
                        _vm._v("短信类型:"),
                      ]),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: "1" },
                          model: {
                            value: _vm.messageType,
                            callback: function ($$v) {
                              _vm.messageType = $$v
                            },
                            expression: "messageType",
                          },
                        },
                        [_vm._v("地址短信")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "marginBottom10" },
                    [
                      _c("div", { staticClass: "marginRight10" }, [
                        _vm._v("发送内容:"),
                      ]),
                      _c("el-input", {
                        attrs: { type: "textarea", rows: 2, readonly: "" },
                        model: {
                          value: _vm.smsContent,
                          callback: function ($$v) {
                            _vm.smsContent = $$v
                          },
                          expression: "smsContent",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { type: "flex", justify: "end" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", plain: "" },
                          on: { click: _vm.onCencer },
                        },
                        [_vm._v("取 消")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.sendSMS },
                        },
                        [_vm._v("确 认")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.closeDialogVisible
            ? _c(
                "el-dialog",
                {
                  staticClass: "videoDialog",
                  attrs: {
                    "close-on-click-modal": false,
                    title: "关闭订单",
                    visible: _vm.closeDialogVisible,
                    width: "350px",
                    "append-to-body": "",
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.closeDialogVisible = $event
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex alignItemsCenter marginBottom10" },
                    [
                      _vm._v(
                        "确认忽略当前选中的#" +
                          _vm._s(_vm.orderInfo.cplatNo) +
                          '订单么?选择"前往自配送"将上传配送信息提升回传率，避免门店被管控？'
                      ),
                    ]
                  ),
                  _c(
                    "el-row",
                    { attrs: { type: "flex", justify: "end" } },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["order:orderProcessing:close"],
                              expression: "['order:orderProcessing:close']",
                            },
                          ],
                          attrs: { type: "primary", plain: "" },
                          on: { click: _vm.handleOrderClose },
                        },
                        [_vm._v("仅忽略")]
                      ),
                      _c(
                        "el-button",
                        { on: { click: _vm.handleDeliverySelf } },
                        [_vm._v("发自配送")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
      _vm.logOrderDialogVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                "close-on-click-modal": false,
                title: "查看日志",
                visible: _vm.logOrderDialogVisible,
                width: "1200px",
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.logOrderDialogVisible = $event
                },
              },
            },
            [
              _vm.logOrderDialogVisible
                ? _c("logOrderDialog", {
                    attrs: { "order-no": _vm.orderInfo.corderNo },
                    on: {
                      handleClose: function ($event) {
                        _vm.logOrderDialogVisible = false
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }